
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/404",
      function () {
        return require("private-next-pages/[domain]/404/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[domain]/404"])
      });
    }
  